import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "alm-react-components";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const ErrorDisplay = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { type } = useParams();
  return (
    <div className="max-sm:portrait:max-w-full max-sm:portrait:w-full max-sm:portrait:min-w-full lg:min-w-[420px] lg:max-w-[420px] portrait:min-w-[420px] portrait:max-w-[420px] md:min-w-[486px] md:max-w-[486px] px-4 mx-auto">
      <Card className="text-base border-0 bg-transparent pt-8 lg:pt-[56px] xl:pt-[86px]">
        <CardHeader className="block p-0">
          <CardTitle className="text-3xl font-light text-center font-barlowMedium dark:color-white">
            <span dangerouslySetInnerHTML={{ __html: t("Common.error") }} />
          </CardTitle>
          <CardDescription className="text-center text-base">
            <span dangerouslySetInnerHTML={{ __html: t(`ErrorType.${type}`) }} />
          </CardDescription>
        </CardHeader>
        <CardContent className="px-0">
          <div className="py-5 text-center w-full">
            <Button
              onClick={() => navigate("/home")}
              className="w-full h-auto py-2 text-base font-opensansBold mb-4"
            >
              <span
                dangerouslySetInnerHTML={{ __html: t("Common.continue") }}
              />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
export default ErrorDisplay;
